import { render, staticRenderFns } from "./CoreManagement.vue?vue&type=template&id=6b4f4670"
import script from "./CoreManagement.vue?vue&type=script&lang=ts"
export * from "./CoreManagement.vue?vue&type=script&lang=ts"
import style0 from "./CoreManagement.vue?vue&type=style&index=0&id=6b4f4670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports